<ng-container *ngFor="let action of secondaryActions()">
  <sh-button
    *ngIf="!action.menu"
    type="button"
    [variant]="action.variant === 'text' ? 'text' : 'outlined'"
    [label]="actionLabel(action)"
    [icon]="action.icon"
    [disabled]="isActionDisabled(action)"
    (click)="runAction(action)"
  ></sh-button>
  <ng-container *ngIf="action.menu">
    <sh-button
      type="button"
      variant="outlined"
      [label]="actionLabel(action)"
      icon="pi pi-chevron-down"
      iconPos="right"
      [disabled]="isActionDisabled(action)"
      (click)="secondaryMenu.toggle($event)"
    ></sh-button>
    <sh-menu #secondaryMenu [items]="action.menu"></sh-menu>
  </ng-container>
</ng-container>
<sh-button
  *ngIf="primaryAction() as action"
  type="button"
  [label]="actionLabel(action)"
  [icon]="action.icon"
  [disabled]="isActionDisabled(action)"
  (click)="runAction(action)"
></sh-button>
<div class="page-actions-divider" *ngIf="hasOverflow()"></div>
<sh-menu-button
  *ngIf="hasOverflow()"
  [items]="overflowActions() ?? []"
></sh-menu-button>
